import Lockr from 'lockr';
import { dayjsTz } from 'v2/core/date/date';
import { Tenant, User } from 'v2/core/entities/user';

function isValidTenant(tenant: Tenant | null): boolean {
  if (tenant == null) {
    return false;
  }

  const { id, timezone, dashboardSettings } = tenant;

  return !!(id && timezone && dashboardSettings);
}

function findTenantForUrlRequest(tenants: Tenant[]): Tenant | null {
  const { pathname } = document.location;

  // eslint-disable-next-line no-useless-escape
  const regexMatch = pathname.match(/^\/([^\/]*).*$/);
  const slugFromUrl = regexMatch?.[1];

  const tenantSlugs = tenants.map(({ slug }) => slug);
  const isTenantExists = tenantSlugs?.includes(slugFromUrl);

  if (isTenantExists) {
    const tenant = tenants.find(({ slug }) => slug === slugFromUrl);

    if (tenant) {
      return tenant;
    }
  }

  return null;
}

function findAdminTenantFromCache(): Tenant | null {
  const tenant: Tenant = Lockr.get('adminTenant');

  if (isValidTenant(tenant)) {
    return tenant;
  }

  return null;
}

export function findTenantFromCache(): Tenant | null {
  const tenant: Tenant = Lockr.get('tenant');

  if (isValidTenant(tenant)) {
    return tenant;
  }

  return null;
}

interface updateAdminTenantOptions {
  baseUser: User;
  onUpdate: (user: User) => void;
  tenants: Tenant[];
}

export const updateAdminTenant = ({
  baseUser,
  onUpdate,
  tenants = [],
}: updateAdminTenantOptions) => {
  const tenant =
    findTenantForUrlRequest(tenants) ||
    findAdminTenantFromCache() ||
    baseUser.tenant;
  const isSameTenant = baseUser.tenant.id === tenant.id;

  if (isSameTenant) {
    onUpdate(baseUser);
  } else {
    tenant.dashboardSettings.startDate = dayjsTz(
      tenant.dashboardSettings.startDate,
    ).tz(tenant.timezone);

    onUpdate({
      ...baseUser,
      tenant,
    });
  }

  Lockr.set('adminTenant', tenant);
};

export default updateAdminTenant;
